
import UserAdd from "../../../assets/duotone/UserAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function UserAddIcon({ className, dataTestid = "UserAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <UserAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
